import { buildEndPoint } from '@mairistem/tools';

import { formatFilters, formatSort } from '@/utils';
import baseUrl from './base';

export const getReglementsPointage = (
  {
    page,
    perPage,
    sorts,
    filters,
    code,
    ...rest
  }: {
    page?: number;
    perPage?: number;
    sorts?: any[];
    filters?: any[];
    [key: string]: any;
  } = {
    page: 1,
    perPage: 1000,
    sorts: [],
    filters: [],
  },
) =>
  buildEndPoint(`${baseUrl}/reglements/pointage`, {
    page,
    perPage: 1000,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    code,
    ...rest,
  });
